module.exports = __webpack_public_path__ + "img/Feature.dd2a5a73.jpg";